export default __webpack_public_path__ + "static/media/7_1_hl.9fa1ad54.png";